import {filterData} from "../components/DropdownFilter";
import {filterCategoryData} from "./filterData";

export function formatCarrierData(cardData: any,
    carrierData: any[], contactData: filterData[],
    facilityData: filterData[], coverageData: filterData[],
    categories: filterData[], companyCategories: any[]) {
    const data = cardData.map((eachData: any)=> {
        const carrier = carrierData.filter((eachCarrier) =>
            eachCarrier.id === eachData.CompanyId)[0];
        const categoriesSelected = companyCategories.filter((category)=>
            eachData.CompanyGroupId === category.companyGroupId);
        const temp = {
            ...eachData,
            coverage: coverageData.filter((coverage) =>
                eachData.CoverageId === coverage.id)[0],
            facilityTypes: facilityData.filter((facility) =>
                eachData.FacilityTypeId.includes(facility.id)),
            contact: contactData.filter((contact) =>
                eachData.ContactId.includes(contact.id)) || {
                        "id": "0",
                        "name": "",
                        "phone": "",
                        "mobile": "",
                        "email": "",
                        "address": "",
                        "submissionEmail": "",
                        "title": "",
                        "department": ""
},
            carrier: carrierData.filter((eachCarrier) =>
                eachCarrier.id === eachData.CompanyId)[0],
            id: eachData.CompanyDetailId,
            name: carrier.value,
            companyId: carrier.id,
            submissionRequirements: eachData.SubmissionRequirement,
            uniqueRequirements: eachData.UniqueRequirements,
            distribution: carrier.Distribution,
            type: carrier.CompanyType,
            notes: eachData.Notes,
            minimumCms: eachData.MinimumCMS,
            minimumTiv: eachData.MinimumTIV,
            groupId: eachData.CompanyGroupId,
            logo: carrier.logo,
            categories: filterCategoryData(categories, categoriesSelected),
            lastUpdated: `${eachData.UpdatedDateTime},${carrier.UpdatedDateTime}`
        }
        return temp;
    });
    return data;
}

export function formatStatesData(data: any, statesData: filterData[]) {
    const temp = data.map((eachData: any)=> {
        const index = statesData.findIndex((state) =>
            state.id === eachData.StateId);
        return (
            {
                id: statesData[index].id,
                value: statesData[index].value,
                abbreviation: statesData[index].abbreviation,
                companyStateId: eachData.CompanyStateId,
            }
        );
    });
    return temp;
}

export function formatCategroryData (data: any) {
    const categories: filterData[] = data.map((eachData: any)=> {
        return (
            {
                id: eachData.categoryId,
                value: eachData.categoryName,
                logo: eachData.fileUrl,
            }
        )
    });
    return categories;
}